// src/services/api.js
export const API_BASE_SOBEVENDA = "https://api.sobevenda.com.br/api-proxy/affiliate";
